export default function tableMixin(columns) {
	return {
		props: {
			loading: Boolean,
			items: Array,
			count: Number,
			refresh: Function,
			sortable: {
				type: Boolean,
				default: true
			},
			pagination: {
				type: Boolean,
				default: true
			}
		},
		computed: {
			table() {
				return { ...this.$props, columns }
			}
		}
	}
}
